export enum FileType {
  CSV = 'text/csv',
  JSON = 'application/json'
}
